<template>
  <Modal name="image" @closeModal="closeModal" size="lg">
    <template v-slot:content>
      <div class="modal__image" v-if="src">
        <img v-if="showAction" :src="src" alt="" />
        <img v-else :src="src" alt="" />
      </div>
      <button
        v-if="showAction"
        @click="showModal()" 
        class="btn btn--primary"
      >
        отдать голос
      </button>
      <a v-else :href="srcDownload" class="btn btn--primary" @click.prevent="clickedDownload(srcDownload)" target="_blank" download>Скачать</a>
    </template>
  </Modal>
</template>

<script>
import Modal from "@/components/Modal.vue";
import axios from "axios";
export default {
  components: {
    Modal,
  },
  data: function () {
    return {
      src: null,
      showAction: false,
      voted: false,
      id: null,
      user: null,
      srcDownload: null,
    };
  },
  methods: {
    closeModal(name) {
      this.$modal.hide(name);
    },
    clickedDownload(url){
        const link = document.createElement('a');
      link.href = url;
      link.setAttribute('download', 'file.png'); //or any other extension
      document.body.appendChild(link);
      link.click();
    },
    forceFileDownload(response){
      const url = window.URL.createObjectURL(new Blob([response.data]))
      const link = document.createElement('a')
      link.href = url
      link.setAttribute('download', 'file.png') //or any other extension
      document.body.appendChild(link)
      link.click()
    },
    downloadWithAxios(url){
      axios({
        method: 'get',
        url: url,
        responseType: 'arraybuffer'
      })
      .then(response => {
        
        this.forceFileDownload(response)
        
      })
      .catch(() => console.log('error occured'))
    },
    downloadWithVueResource(url) {
      
      this.$http({
        method: 'get',
        url: url,
        responseType: 'arraybuffer'
      })
      .then(response => {
        this.forceFileDownload(response)  
      })
      .catch(() => console.log('error occured'))
      
    },
    beforeOpen(event) {
      console.log(event);
      this.src = event.params.src;
      this.showAction = event.params.showAction;
      this.voted = event.params.voted;
      this.id = event.params.id;
      this.user = event.params.user;
      this.srcDownload = event.params.download;
    },
    showModal() {
      this.$modal.hide('image');
      if (this.user) {
        if (!this.voted) {
          this.$store.dispatch("AddLike", {
            photo_id: this.id,
          })
          .then((r) => {
            if (!r.result) {

              let fieldsError = null;

              if (r.error && !fieldsError) {
                this.$modal.hide("image");
                this.$modal.show("common_error", {
                  title: r.error,
                });
              }
            } else {
              this.$store.dispatch("GetProfile");
              this.$store.dispatch("GetPhotos", { page: 1});
              this.$modal.show('common_success', {
                title: 'Вы успешно проголосовали',
              });
              this.gtmEvent("vot_work", "do", "internal");
            }
          })
        } else {
          this.$modal.show('common_success', {
            title: 'Вы ранее уже голосовали',
          })
        }
      } else {
        // this.$modal.show('temporarily_unavailable');
        this.$modal.show('authorization');
      }
    }
  },
};
</script>
